export default "__VITE_ASSET__BJSg8Ntv__"